import { ChangeDetectorRef, Component } from '@angular/core';
import { HeaderNewComponent } from '../header/header-new.component';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule, NgIf } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FoundCustomer } from 'src/app/models/model/foundCustomer';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationModalService } from 'src/app/services/confirmation-modal.service';
import { Store } from '@ngxs/store';
import { ApiConnectorService } from 'src/app/services/api-connector.service';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { Observable } from 'rxjs';
import { PersonalDataStateModel, UpdatePersonalDataState } from '../../../state/personal-data.state';
import { CustomerInfo } from 'src/app/models/application.model';
import { GlobalLoaderComponent } from 'src/app/components/global-loader/global-loader.component';
import { AppRoutes, AppRoutesFlow } from 'src/app/app-routing.module';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ResetAllStates } from 'src/app/state/reset.reducer';

@Component({
  selector: 'app-customer-search',
  standalone: true,
  imports: [
    HeaderNewComponent,
    FooterComponent,
     NgIf,
     FormsModule,
    ReactiveFormsModule,
     BottomNavComponent,
    CommonModule,
    GlobalLoaderComponent
  ],
  templateUrl: './customer-search.component.html',
  styleUrl: './customer-search.component.scss'
})
export class CustomerSearchComponent {

  customerSearchForm: FormGroup = {} as FormGroup;
  customDobError: boolean = false;
  enableResultSection: boolean = false;
  customerList: FoundCustomer[] = [];
  backRoute: string = '';
  enableSubmit: boolean = false;
  productName: any;
  appState: any;
  personalState$!: Observable<PersonalDataStateModel> | any;
  firstName: any;

  constructor(
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private router: Router,
    private application: ApiConnectorService,
    private modalSvc: ConfirmationModalService,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private sessionStorage: SessionStorageService
  ) { }


ngOnInit(): void {
   //this.store.dispatch(new ResetAllStates());

    this.initForm();

    this.f['firstName'].valueChanges.subscribe({
      next: () => {
        this.enableResultSection = false;
        this.enableSubmit = false;
        this.customers.clear();
      },
    });

    this.f['lastName'].valueChanges.subscribe({
      next: () => {
        this.enableResultSection = false;
        this.enableSubmit = false;
        this.customers.clear();
      },
    });

    this.f['dob'].valueChanges.subscribe({
      next: () => {
        this.enableResultSection = false;
        this.enableSubmit = false;
        this.customers.clear();
      },
    });
    // if(this.productName === GlobalConstants.AID_ACCOUNT){
    //   this.backRoute = AppRoutes.AID_INTRO_PAGE;
    // }
    // else {
    //   this.backRoute = AppRoutes.ACCOUNTS_OVERVIEW;
    // }
    
     this.backRoute = AppRoutes.OVERVIEW;
   
  }


  onBack() {
    this.router.navigate(['../../',AppRoutes.OVERVIEW], {
      queryParams: { productName: this.productName },
    });
  }
   get f() {
    return this.customerSearchForm.controls;
  }

  get customers(): FormArray {
    return this.customerSearchForm.controls['selectCustomer'] as FormArray;
  }

    initForm() {
      this.customerSearchForm = this.fb.group({
        searchBasedOn: ['kundenname', Validators.required],
        firstName: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+$"
            ),
            Validators.maxLength(30),
          ]),
        ],
        lastName: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+$"
            ),
            Validators.maxLength(30),
          ]),
        ],
        dob: [
          '',
          Validators.compose([Validators.required]),
        ],
        iban: [''],
        selectCustomer: this.fb.array([]),
      });
    }

     focusDob() {
    if (this.customDobError) {
      this.customDobError = false;
      this.cd.detectChanges();
    }
  }

  onResultSelection() {
    if (this.isAnyRadioSelected()) {
      this.enableSubmit = true;
    }
  }

   onCustomerSearch({ value, valid }: { value: any; valid: boolean }) {
    let body: CustomerInfo = {};
    if (value.searchBasedOn === 'kundenname') {
      body = {
        firstName: value.firstName,
        lastName: value.lastName,
        birthDate: value.dob,
      };
    } else {
      body = {
        iban: value.iban,
      };
    }
    this.customers.clear();
    this.application
      .searchCustomers(value.searchBasedOn === 'kundenname', body)
      .subscribe({
        next: (res: FoundCustomer[]) => {
          this.enableResultSection = true;
          this.customerList = res;
          this.personalState$ = this.store.select((state) => state.personalData);
    
      this.store.dispatch(new UpdatePersonalDataState({
     firstName: value.firstName,
  lastName: value.lastName,
  birthDate: value.dob,
   customerNumber: res[0]?.customerNumber || '',

}));
          if (res && res.length > 0) {
            if (res.length === 1) {
              this.enableSubmit = true;
              res.forEach(item => {
                this.customers.push(
                  this.fb.group({
                    selected: [true],
                    name: [item.firstName + ' ' + item.lastName],
                    birthDate: [item.birthDate],
                    address: [item.street + ', ' + item.postalCode + ' ' + item.city],
                    customerNumber: [item.customerNumber  ],
                    // number: [item.number],
                    // entity: [item.entity],
                  })
                );
              });
            } else {
              res.forEach(item => {
                this.customers.push(
                  this.fb.group({
                    selected: [false],
                    name: [item.name],
                    birthDate: [item.birthDate],
                    address: [item.address],
                    number: [item.number],
                    entity: [item.entity],
                  })
                );
              });
            }
          }
        },
      });
  }

   isAnyRadioSelected(): boolean {
    const items = this.customerSearchForm.controls['selectCustomer'] as FormArray;
    return items.controls.some(item => item.value.selected === false);
  }

  retrieveSelectedData() {
    const items = this.customerSearchForm.controls['selectCustomer'] as FormArray;
    return items.controls.find(item => item.value.selected === true);
  }

    onSubmit({ value, valid }: { value: any; valid: boolean }) {
     if (valid && this.enableSubmit) {
       if(this.sessionStorage.getProductName() === 'change-address') {
        this.router.navigate([AppRoutes.FLOW,'data',AppRoutesFlow.CHANGE_ADDRESS]);
       }
       else if(this.sessionStorage.getProductName() === 'change-contact') {
        this.router.navigate([AppRoutes.FLOW,'data',AppRoutesFlow.CHANGE_PHONENUMBER]);
       }
        else if(this.sessionStorage.getProductName() === 'change-name') {
        this.router.navigate([AppRoutes.FLOW,'data',AppRoutesFlow.CHANGE_NAME]);
       }
        else if(this.sessionStorage.getProductName() === 'change-email') {
        this.router.navigate([AppRoutes.FLOW,'data',AppRoutesFlow.CHANGE_EMAIL]);
       }
      // const selectedObj = this.retrieveSelectedData();
      // const jointAccount: AllegroCustomer = {
      //   entity: selectedObj?.value.entity,
      //   number: selectedObj?.value.number,
      // };
      // this.application
      //   .checkOtherProduct(jointAccount, this.productName)
      //   .pipe(take(1))
      //   .subscribe({
      //     next: () => {
      //       const coApplicant: InitCoApplicant = {
      //         customer: jointAccount,
      //       };

      //       this.updatePersonalDataState$?.emit({
      //         coApplicants: coApplicant,
      //       });
      //       this.otherDecisionMaker.initApplication();
      //     },
      //   });
    }
  }
  

}
